import React, { type ReactNode } from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    variant?: 'dark' | 'light';
    fullWidth?: boolean;
}

const ArrowIcon = () => (
    <svg
        width='19'
        height='19'
        viewBox='0 0 19 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.92871 0.337402L18.0859 9.0376L18.2119 9.15771L18.085 9.27783L8.92871 17.9653L8.81445 18.0737L8.7002 17.9644L7.76172 17.064L7.63672 16.9438L7.7627 16.8247L15.0078 9.94482H0.165039V8.34521H15.0068L7.7627 1.47803L7.63672 1.35889L7.76172 1.23877L8.7002 0.338379L8.81445 0.229004L8.92871 0.337402Z'
            fill='currentColor'
        />
    </svg>
);

export const ActionButton: React.FC<ButtonProps> = ({
    children,
    variant = 'dark',
    fullWidth = false,
    disabled = false,
    onClick,
    className = '',
    ...props
}) => {
    // Base classes
    const baseStyles =
        'inline-flex items-center justify-center gap-5 rounded-lg px-5 py-3.5 outline outline-2 transition-all';

    // Dynamic states
    const stateStyles = disabled
        ? 'opacity-50 cursor-not-allowed'
        : 'cursor-pointer active:scale-[0.98] hover:opacity-90';

    const widthStyles = fullWidth ? 'w-full' : 'w-auto';

    // Variant mapping
    const variants = {
        dark: 'bg-[var(--colour-charcoal-dark)] outline-[var(--colour-white)] text-[var(--colour-white)]',
        light: 'bg-white outline-[var(--colour-charcoal-dark)] text-[var(--colour-charcoal-dark)]',
    };

    return (
        <button
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            className={`${baseStyles} ${stateStyles} ${widthStyles} ${variants[variant]} ${className}`}
            {...props}>
            <div className="font-['Effra'] text-xl leading-7 font-bold uppercase">{children}</div>

            <div className='flex items-center justify-start'>
                <div className='inline-flex items-center justify-center rounded-[36.72px] bg-[var(--colour-gold)] p-2.5 text-[#0B0B0B]'>
                    <ArrowIcon />
                </div>
            </div>
        </button>
    );
};
